export default "__VITE_ASSET__CMQGq9Rt__"